/**
 * @generated SignedSource<<b7c7f2648816aa5299c456b978b845b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventScreenNewMobile_event$data = {
  readonly description: string | null | undefined;
  readonly endAt: string;
  readonly hasExternalUrl: boolean | null | undefined;
  readonly hasVenue: boolean | null | undefined;
  readonly name: string;
  readonly owner: {
    readonly __typename: "Guild";
    readonly sponsorshipDisplay: boolean | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly prettyUrl: string;
  readonly seoVenue: {
    readonly address: {
      readonly city: string | null | undefined;
      readonly countryCode: string | null | undefined;
      readonly stateProvinceRegionCode: string | null | undefined;
      readonly zipPostalCode: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly startAt: string;
  readonly " $fragmentSpreads": FragmentRefs<"EventHostInvitationBanner_event" | "EventScreenAttendCard_event" | "EventScreenDateTime_event" | "EventScreenDescription_event" | "EventScreenJoin_event" | "EventScreenMap_event" | "EventScreenNewCoverPhoto_event" | "EventScreenOwner_event" | "EventScreenPresentations_event" | "EventScreenSettingsButton_event">;
  readonly " $fragmentType": "EventScreenNewMobile_event";
};
export type EventScreenNewMobile_event$key = {
  readonly " $data"?: EventScreenNewMobile_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenNewMobile_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenNewMobile_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasVenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExternalUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Venue",
      "kind": "LinkedField",
      "name": "seoVenue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "city",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stateProvinceRegionCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "zipPostalCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "countryCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sponsorshipDisplay",
              "storageKey": null
            }
          ],
          "type": "Guild",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenNewCoverPhoto_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenDescription_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenSettingsButton_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenDateTime_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenOwner_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenJoin_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenPresentations_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenAttendCard_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenMap_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventHostInvitationBanner_event"
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "97aff73223ade4a9d9aafa3f1712081f";

export default node;
